import { defineStore } from 'pinia';
import { useServiceStore } from '@modules/service/m-service';
import { useProfilesStore } from '../profiles/m-profiles';
import { useSirvaseStore } from '@/store/modules/sirvase/m-sirvase';
import { useSessionStore } from '@/store/modules/session/m-session';

export const useContractsStore = defineStore('m-contracts', {
	state: () => ({
		connectedContract: null,
		isSegurosContract: false,
	}),

	actions: {
		setConnectedContract(contract) {
			this.connectedContract = contract;
		},

		setIsSegurosContract(value) {
			this.isSegurosContract = value;
		},

		reset() {
			this.connectedContract = null;
		},

		get() {
			const serviceStore = useServiceStore();
			return serviceStore
				.request({
					service: {
						request: {
							url: '/contracts',
							method: 'GET',
						},
					},
				})
				.then(({ data }) => data)
				.catch((err) => err);
		},

		async set(contract) {
			const { connectedContract } = this;

			if (connectedContract?.id === contract?.id) {
				return connectedContract;
			}

			const { id, description } = contract;
			const lowerCaseDescription = description?.toLowerCase();

			if (lowerCaseDescription) {
				this.setIsSegurosContract(lowerCaseDescription === 'seguros');
			}

			const url = `/contracts/${id}`;
			const method = 'PATCH';

			const serviceStore = useServiceStore();

			return serviceStore
				.request({
					service: {
						request: {
							url,
							method,
						},
					},
				})
				.then(({ data }) => {
					const profilesStore = useProfilesStore();
					profilesStore.get();
					useSessionStore().markUserNotGreeted();
					useContractsStore()
						.getCurrentContract()
						.then((data) => {
							const { connectedContract } = data;
							this.setConnectedContract(connectedContract);
						})
						.catch(() => {
							this.setConnectedContract(data);
						});
					useSirvaseStore().reset();
					useSirvaseStore().getPersonalManagers();
					return data;
				})
				.catch((error) => Promise.reject(error));
		},

		getInterveners(idContract) {
			const serviceStore = useServiceStore();

			return serviceStore
				.request({
					service: {
						request: {
							url: `/contracts/${idContract}/interveners`,
							method: 'GET',
						},
					},
				})
				.then(({ data }) => data)
				.catch(() => {});
		},

		getCurrentContract() {
			const serviceStore = useServiceStore();
			return serviceStore
				.request({
					service: {
						request: {
							url: '/contracts/current',
							method: 'GET',
						},
					},
				})
				.then(({ data }) => data)
				.catch((err) => err);
		},
	},
});
